import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { ObjectTypeIdRegex } from '../filterQueryFormat/ObjectTypeId';
import { SEQUENCE_ENROLLMENT_TYPE_ID } from '../constants/objectTypeIds';
const externalOptionsForAnyTypeAllowList = {
  [SEQUENCE_ENROLLMENT_TYPE_ID]: {
    hs_sequence_id: true
  }
};
export const applyExternalOptionsOverrides = (assetFamily, data) => {
  const allowListForAssetFamily = externalOptionsForAnyTypeAllowList[assetFamily];
  if (!allowListForAssetFamily) {
    return data;
  }
  return data.map(field => {
    const shouldOverride = field.constructor !== MissingField && !!allowListForAssetFamily[field.get('name')] && !!field.get('externalOptions') && field.get('type') !== ENUMERATION;
    if (shouldOverride) {
      return field.merge({
        type: ENUMERATION,
        displayType: ENUMERATION,
        fieldType: 'select'
      });
    }
    return field;
  });
};
export const applyFieldDefinitionOverrides = (assetFamily, data, fieldDefinitions) => {
  // only attempt for crm objects
  if (!ObjectTypeIdRegex.test(assetFamily)) {
    return data;
  }

  // and if there are overrides set
  if (!fieldDefinitions || Object.keys(fieldDefinitions).length === 0) {
    return data;
  }
  return data.map(field => {
    if (field.constructor === MissingField) {
      return field;
    }
    const override = fieldDefinitions[field.name];
    return override ? field.merge(override) : field;
  });
};